import { useCallback, useRef } from 'react';
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { useTemplateVariables } from "../TemplateVariablesContext";
import { useInsertVariableIntoTextField } from "./useInsertVariableIntoTextField";
import { useTextFieldKeyboardTrigger } from "./useTextFieldKeyboardTrigger";
import { useVariablePicker } from "./useVariablePicker";
export function useTextFieldVariableIntegration(inputRef, setValue) {
  let config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    disabled,
    excludeLabels,
    adornmentStyle
  } = config;
  const {
    TEMPLATE_VARIABLES
  } = useFeatureFlags();
  const {
    customVariables,
    resolvedValues
  } = useTemplateVariables();
  const {
    pickerState,
    openPicker,
    closePicker
  } = useVariablePicker();
  const adornmentRef = useRef(null);
  const handleInsertVariable = useInsertVariableIntoTextField(inputRef, setValue);
  const handleKeyDown = useTextFieldKeyboardTrigger(inputRef, setValue, openPicker, handleInsertVariable);
  const enabled = !!TEMPLATE_VARIABLES;
  const inputProps = enabled ? {
    onKeyDown: handleKeyDown
  } : undefined;
  const handleAdornmentClick = useCallback(() => {
    if (adornmentRef.current) {
      openPicker(adornmentRef.current, handleInsertVariable);
    }
  }, [openPicker, handleInsertVariable]);
  const handleSelect = useCallback(label => {
    var _pickerState$onInsert;
    (_pickerState$onInsert = pickerState.onInsert) === null || _pickerState$onInsert === void 0 || _pickerState$onInsert.call(pickerState, label);
    closePicker();
  }, [pickerState, closePicker]);
  const handleClose = useCallback(() => {
    var _pickerState$onDismis;
    (_pickerState$onDismis = pickerState.onDismiss) === null || _pickerState$onDismis === void 0 || _pickerState$onDismis.call(pickerState);
    closePicker();
  }, [pickerState, closePicker]);
  return {
    enabled,
    inputProps,
    adornmentRef,
    adornmentStyle,
    fieldAdornmentProps: {
      onClick: handleAdornmentClick,
      disabled
    },
    resolvedValues,
    pickerPopoverProps: {
      anchorEl: pickerState.anchorEl,
      customVariables,
      excludeLabels,
      onSelect: handleSelect,
      onClose: handleClose
    }
  };
}